import React from "react";
import { Link } from "react-router-dom";
import { Clock, AlertTriangle } from "lucide-react";

export default function DemoBanner({ demoInfo }) {
  if (!demoInfo?.is_demo || demoInfo?.demo_expirado) return null;

  const dias = demoInfo?.dias_restantes;
  const urgent = dias !== null && dias !== undefined && dias <= 2;
  const diasTxt =
    dias === null || dias === undefined
      ? ""
      : dias === 0
      ? " · Expira hoy"
      : ` · ${dias} día${dias !== 1 ? "s" : ""} restante${dias !== 1 ? "s" : ""}`;

  return (
    <div
      className={`flex items-center justify-between px-4 py-2 text-sm border-b ${
        urgent
          ? "bg-amber-50 border-amber-200 text-amber-800"
          : "bg-blue-50 border-blue-200 text-blue-700"
      }`}
    >
      <span className="flex items-center gap-1.5 font-medium">
        {urgent ? (
          <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0" />
        ) : (
          <Clock className="w-4 h-4 text-blue-400 shrink-0" />
        )}
        {`Modo demo${diasTxt}`}
      </span>
      <Link
        to="/app/onboarding"
        className={`text-xs font-semibold underline underline-offset-2 ml-4 whitespace-nowrap ${
          urgent ? "text-amber-700 hover:text-amber-900" : "text-blue-600 hover:text-blue-800"
        }`}
      >
        Activar plan →
      </Link>
    </div>
  );
}
